import   React, 
       { createContext,
         useState,
         useEffect } from 'react';
import { Route, 
         BrowserRouter,
         withRouter,
         Redirect, 
         Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import reducer from '../util/reducer';
import Splash from './Splash';
import Tutorial from './Tutorial';
import Webcam from './Webcam';
import Learn from './Learn';
//import Analyze from './Analyze';
//import Menu from './Menu';
import Auth from './Auth';
import Dev from './Dev';
import Gif from './Gif';        // make animated gif
import { Dashboard } from './Dashboard';
import { FullScreen,
         Policy } from './Util';
import { processServiceWorkerReload,
         processStateItems,
         loadUserState,
         setScreenOrientation,
         checkRealTimeResponse,
         processInviteKey,
         process_user_invite,
         process_temp_anon_login,
         set_webcam_resolution,
         setPWANotificationState,
         loadClientInfo,
         processMenuItems } from "../util/util";
import { probeWebcamDim }  from '../util/videoUtil';
import { STATS,
         TIMES,
         REACT_STATES,
         storeConsoleLog, 
         INFO, 
         CONSTS} from '../util/object'
import { getIP, 
         startUser, 
         inviteUser, 
         makeUserKey,
         ReadMenuData,
         ReadStateData,
         ReadHomeOrgData,
         ReadLeaderData,
         FetchSplashInfo,
         storeAllSessionData } from '../util/database';
import { UtilClass } from '../class/UtilClass';
import { checkAuthResponse,
         getRedirectResult,
         AuthClass } from '../class/AuthClass';
import { REST_API_SERVER } from '../util/constants'
import { AXOS_VERSION } from '../version';
import PRIVACY from '../assets/text/privacy.txt';
import TOS from '../assets/text/tos.txt';
import DELETION from '../assets/text/deletion.txt';
import { browserDownloadsRouter } from '@tensorflow/tfjs-core/dist/io/browser_files';
//import { addToHomeScreen } from '../util/addToHomeScreen';

export const appContext = createContext(null);   // use this everywhere in the app
const app_useStyles = makeStyles(theme => ({
    main_root: {
      display: "block",
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',     // IMPORTANT!
      position: 'fixed',
      top: 0,
      left: 0,
      margin: 0,
      padding: 0,
      backgroundColor:'#e1eaf5',
      //flexGrow: 1,
      //backgroundColor:'red',
    },
}));


// DON'T THINK THIS WORKS....
// detect pull down refresh on IOS
var LastScrollPosition = 0;
window.onscroll = function(event) {
    console.log("index.51:    ***** SCROLL:  scrollTop=", document.body.scrollTop, " lastpos=",LastScrollPosition);
    if(((document.body.scrollTop >= 0) && (LastScrollPosition < 0)) ||
      ((document.body.scrollTop == 0) && (LastScrollPosition > 0))) {
        console.log("index.83: ******  PULL DOWN REFRESH DETECTED!!!!   ");
    }
    LastScrollPosition = document.body.scrollTop;
}

const Util = new UtilClass();
var auth = new AuthClass();

const App = (props) => {
    const classes = app_useStyles();
    const [State, Dispatch] = React.useReducer(reducer, REACT_STATES); // React Global Vars - share state between REACT modules
    const setState = (name, value) => {
        //console.log("setState.idx:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ ShowUpdate, setShowUpdate ] = useState(false);
    const [ Crash, setCrash ] = useState(null);
    const [ PolicyText, setPolicyText ] = useState([]);
    const [ ButtonText, setButtonText ] = useState(null);
    const [ ButtonAction, setButtonAction ] = useState(null);

    useEffect(() => {
        var content = null;
        var path = props.location.pathname;
        var search = props.location.search;
        var authed = auth.getAuthed();
        setState('authed', authed);
        var init_visit = auth.getCookie(CONSTS.COOKIE_INIT_VISIT);  
        var now = Date.now();
        var tdelta = now - init_visit;

        loadClientInfo();       // Do this early to avoid race condition with <Splash>

        // KLUDGE: if less than 10 min from first visit, assume auth redirect, restore params to finish inivte
        //     - the issue is after auth redirect, the initial params are lost, so we store in cookie
        //     - but need to do a semaphore so we process the invite only once
        //
        if (tdelta < (10 * 60 * 1000)) {
            // check to see if this is an invite flow post auth
            //
            var s_url = auth.getCookie(CONSTS.COOKIE_STARTING_URL); 
            var s_search = auth.getCookie(CONSTS.COOKIE_SEARCH);        
            var s_path = auth.getCookie(CONSTS.COOKIE_PATH);        
            INFO.starting_url = s_url;
            path = s_path;
            search = s_search;
        }

        var show_debug = false;
        if (show_debug) {
            probeWebcamDim();       // DEBUG: One time only
        }


        console.log("index.100: +++++++++++++++++++++ INDEX  path=", path, " search=", search, " authed=",authed, " chain=",INFO.drill_chain_mode, " API_host=", REST_API_SERVER);
        console.log("index.131: +++++++++++++++++++++        PREV  tdelta=",tdelta.toFixed(0), " starting_url=",INFO.starting_url, " invite_key=",INFO.invite_key, "  splash=",INFO.splash_image);

        switch(path) {
            case "/privacy":
                content = PRIVACY;
                break;
            case "/tos":
                content = TOS;
                break;
            case "/deletion":
                content = DELETION;
                break;
            case "/gif":
                // example: axos.cc/gif?[v,d]=<id>
                //    - d = <drill_key>
                //    - v = <video_hash>
                //
                var search = props.location.search;
                var key = search.slice(1, search.length);
                var key_bits = key.split("=");
                var val = key_bits[1];
                var mode = key_bits[0];     // [v:video, d:drill]
                switch(mode) {
                    case "v":
                        INFO.gif_video_hash = val;
                        break;
                    case "d":
                        INFO.gif_drill_key = val;
                        break;
                }
                //setGifHash(hash);
                console.log("index.252:        START GIF MODE   mode=",mode, " val=",val);
                //INFO.redirect_path = "/gif";
                return;     // do not go anywhere else
        }

        // if display only page, do not continue
        if(content !== null) {
            fetch(content)
            .then(r => r.text())
            .then(text => {
                var out = [];
                var bits = text.split("\n");
                for(var i=0; i < bits.length; i++) {
                    out.push(bits[i]);
                }
                console.log('index.129:        POLICY text decoded:', bits.length);
                setPolicyText(out);
            });
            console.log("")
            return;     // just show some text
        }

        // only detect for non-developer sessions
        //
        //if ((window.location.hostname !== "localhost") && (window.location.hostname !== "127.0.0.1") &&
        if ((window.location.hostname === "localhost") || (window.location.hostname === "127.0.0.1")) {
            INFO.localhost = true;
        } else {
            if (INFO.device.speed < CONSTS.MIN_AI_MODE_SPEED) {
                console.log("index.88: XXXXXX DEVICE TOO SLOW FOR AI!!!");
                INFO.no_ai_mode = true;
                INFO.show_no_ai = true;
            }
        }

        // default: use subdomain for splash page
        var full = window.location.host;
        var parts = full.split('.');
        var subdomain = parts[0];
        INFO.splash_image = subdomain;


        // Process Param Arguments:
        //    INVITE_KEY link ("i=<invite_key>")
        //      - store invite_key in cookie, so first call to server will trigger setup process
        //      - after login: call SERVER /user/invite/<firebase_uid>/<invite_token> bind with proper memberships
        //
        //    DRILL link ("d=<invite_key>+<drill_key>")
        //      - enter as anon player for this youtube chan
        //      - invited by youtube-chan-user, but no firebase_uid
        //      - call SERVER /user/drill/<youtube_drill_id> to get all public drills and temp_ID
        //      - store temp_ID in cookie for late binding (if signs up)
        //      - backend need to re-ID all records after sign up 
        //
        //INFO.invite_key = "axos";       // BAD: this breaks things, need some other way
        //INFO.uid = auth.getUid();       // get firebase_uid if already got one
        INFO.uid = auth.getCookie(CONSTS.COOKIE_FB_UID);        // get firebase_uid if already got one
        INFO.uid = (INFO.uid === false) ? null : INFO.uid;      // rest of system expects null
        INFO.invite_key = null;
        if ((props !== undefined) && (props.location !== undefined)) {
            var key = search.slice(1, search.length);
            var key_bits = key.split("=");
            var drill_key = key_bits[1];
            //var path = props.location.pathname;
            //INFO.starting_url = window.location.href;
            INFO.starting_url = "https://" + window.location.host + path + search;
            console.log("index.171: +++++++++++++++++++++ INDEX  url=",INFO.starting_url, "  location=", props.location, "  State.authed=",State.authed,  "  cookie.authed=",authed, " splash=",INFO.splash_image);

            if (key_bits.length == 2) {
                if (authed === false) {
                    // preserve the initial entry for processing new user post-auth
                    //     - store only if an invite and not authed
                    //
                    auth.setCookie(CONSTS.COOKIE_STARTING_URL, INFO.starting_url);       // remember this for later
                    auth.setCookie(CONSTS.COOKIE_INIT_VISIT, Date.now());       // remember this for later
                    auth.setCookie(CONSTS.COOKIE_SEARCH, search);        
                    auth.setCookie(CONSTS.COOKIE_PATH, path);        
                    console.log("index.238:                Preserve Invite State  s_url=",INFO.starting_url, "  search=", search, "  path=",path);
                }


                switch (key_bits[0]) {
                    case "i":
                        INFO.invite_key = key_bits[1];
                        //var key = processInviteKey(key_bits[1]);      // start process only after login
                        processInviteKey(key_bits[1]) 
                        .then(key => {
                            if (key !== false) {
                                INFO.invite_key = key;
                                //auth.setSplash(INFO.invite_key);       // remember this for later
                                auth.setCookie(CONSTS.COOKIE_SPLASH, INFO.invite_key);       // remember this for later
                                auth.setCookie(CONSTS.COOKIE_INVITE, INFO.invite_key);       // remember this for later
                            }
                            //setState("invite_mode", true);
                            //setState("target_path", "/menu");
                            INFO.redirect_path = "/menu";
                        })
                        break;

                    case "d":
                        // process youtube single drill (same path as demo_anon flow)
                        //   - "?d=<invite_key>:<drill_hash>" or "<link>"
                        //   - check cookie if anon-user already setup (repeater)
                        //   - do a anon login, system creates a record and returns a temp ID
                        //   - drop cookie so we can keep adding to this anon user
                        //   - display splash intro
                        //   - server return anon metadata for this publisher
                        //   - hotpath to the drill
                        //   - at end of drill, show other drills by publisher
                        //
                        console.log("index.210:        ENTER AUTO PLAY:  authed=",State.authed, "  cookie.authed=",authed);
                        var drill_bits = drill_key.split("+");      // KLUDGE: MAKE SURE INVITE_KEY & DRILL_ID HAS NO "+"
                        INFO.invite_key = drill_bits[0];
                        INFO.drill_hash = drill_bits[1];
                        INFO.direct_start_mode = true;
                        INFO.email = INFO.anon_email;
                        //auth.setSplash(INFO.invite_key);       // remember this for later
                        auth.setCookie(CONSTS.COOKIE_SPLASH, INFO.invite_key);       // remember this for later
                        auth.setCookie(CONSTS.COOKIE_INVITE, INFO.invite_key);       // remember this for later

                        //splash = INFO.invite_key;           // get custom splash for this invite
                        //setState("invite_mode", true);
                        //setState("target_path", "/drill");
                        setState("drill_key", INFO.drill_hash);
                        INFO.redirect_path = "/auto1";      // auto run 1 drill
                        if (authed === true) {

                            // call invite and add program to the existing account
                            var invite_promise = inviteUser(INFO.uid, INFO.invite_key);
                            console.log("index.225:          INVITE EXITING USER inviteUser() promise=",invite_promise);

                        } else {
                            var login_promise = process_temp_anon_login(State, setState);
                            Promise.all([ login_promise ])
                            .then((res) => {
                                console.log("index.195:        LOGIN SUCCESS!  from process_temp_anon_login() =", res);
                                //process_user_invite("index.193");     // moved to inviteUser()
                            })
                        }

                        break;

                    case "v":
                        // Create animated gif for drill preview from video
                        //    - ?v=[y,t]:<video_id>
                        //    - when on localhost run https://cors-anywhere.herokuapp.com/corsdemo 
                        //    - saves gif on local file
                        //
                        var hash = key_bits[1];
                        //setGifHash(hash);
                        console.log("index.252:        START GIF MODE   hash=",hash);
                        INFO.redirect_path = "/gif";
                        break;

                    default:
                        //setState("invite_mode", false);
                        //setState("entry_path", "/menu");
                        INFO.redirect_path = "/menu";
                        break;
                }
            }
        }

        if (!INFO.localhost) setPWANotificationState();       // figure out what state we are in
        prepare_splash_info(INFO.drill_hash, INFO.invite_key, INFO.uid, subdomain);


        // quick fetch from backend, get it before user_state returns
        //    - Direct Drill:  Has: drill_hash, invite_key (/invite/drill_hash/invite_key)
        //    - Regular Invite:  Has: invite_key  (/invite/null/invite_key)
        //    - User Login:  Has: firebase_uid (/invite/_user/fb_id)
        //    - Subdomain:  Has: subdomain  (/invite/subdomain/null)

        async function prepare_splash_info(drill_hash, invite_key, firebase_uid, subdomain) {
            var splash = null;

            //splash = auth.getSplash();       // check if one in cookie from last time
            splash = auth.getCookie(CONSTS.COOKIE_SPLASH);
            if (invite_key !== null) {
                INFO.splash_image = invite_key;
            } else if (subdomain !== "axos") {
                INFO.splash_image = subdomain;
            } else if ((splash !== null) && (splash !== false)) {
                INFO.splash_image = splash;
            }
            console.log("index.268:    splash_image=",INFO.splash_image,"  splash=",splash, "  invite_key=",invite_key, " drill_hash=",drill_hash, " subdomain=",subdomain);

            // pre-cache flash image to make it feel more snappy
            // src: https://stackoverflow.com/questions/42615556/how-to-preload-images-in-react-js
            const newImage = new Image();
            var image = CONSTS.SPLASH_ASSET_PATH + INFO.splash_image;
            newImage.src = image;
            window[image] = newImage;

            await FetchSplashInfo(drill_hash, invite_key, firebase_uid, subdomain);
        }


        // setup persistent states
        //
        TIMES.app_entry = Date.now();
        INFO.admin_mode = false;    // unless called with /admin
        INFO.mock_type = "target";      // easier to override, [ measure, target, passing, position, defend, path, long ]
        INFO.mock_create_type = "target";      // easier to override, [ measure, target, passing, position ]

        // initialize webcam resolution, can be chgd later
        //
        set_webcam_resolution("low");        // [ low, med, high ]

        // get user info based on IP
        //
        getIP()
        .then(ip =>{
            console.log("get_IP.98: ***** GOT IP_INFO:  ", JSON.stringify(ip));
            INFO.user_location = ip.country+"-"+ip.region_code+"-"+ip.city+"-"+ip.latitude+":"+ip.longitude;
            INFO.ip_info = ip;
        })
        .catch(err =>{
            console.log("getIP.101:  ERROR ", err)
        })



        if(CONSTS.FORCE_NO_BALL_DETECT === true) {
            INFO.skip_ball_detect = true;	// one way trip
        }

        INFO.scale_factor = (window.innerWidth + window.innerWidth) / 1000;   // for font scaling

        // set up service worker
        //
        const swUrl = `${process.env.PUBLIC_URL}/custom-service-worker.js`;
        if ((swUrl !== undefined) && (swUrl !== null)) {
            //navigator.serviceWorker.ready
            if(navigator.serviceWorker !== undefined) {
                navigator.serviceWorker.register(swUrl)
                .then(function(reg) {
                    var installing = reg.installing;   // still installing
                    var waiting = reg.waiting;   // installed but waiting
                    var active = reg.active;   // currently running version
                    INFO.service_worker = active;

                    if ((active !== null) && (active !== undefined)) {
                        console.log('IDX-SVC.116: FOUND ACTIVE Service Worker @', active.scriptURL, " is ", active.state);
                        INFO.service_worker.postMessage('AXOS RUNNING ver='+AXOS_VERSION);
                    } else {
                        console.log('IDX-SVC.132: FOUND *NO* Active Service Worker');
                        INFO.show_download = true;
                    }
                    
                    if ((installing !== null) && (installing !== undefined)) {
                        console.log('IDX-SVC.126: HAS INSTALLING Service Worker @', installing.scriptURL, " is ", installing.state);
                    } 
                    
                    if ((waiting !== null) && (waiting !== undefined)) {
                        console.log('IDX-SVC.129: HAS WAITING Service Worker @', waiting.scriptURL, " is ", waiting.state);
                        INFO.show_download = true;
                    }
                })
            } else {
                console.log('IDX-SVC.353:   INSERCURE, UNABLE TO REGISTER SERVICE WORKER  @', swUrl);
            }
        }

        // system real time check, show perf light (green, yellow, red)
        INFO.check_realtime_start = Date.now();
        setTimeout(()=> {
            checkRealTimeResponse();
        },  CONSTS.REALTIME_CHECK_INTERVAL);


        // delayed start of login auth
        // ref: https://stackoverflow.com/questions/1190642/how-can-i-pass-a-parameter-to-a-settimeout-callback
        //
        setTimeout( checkAuthResponse.bind(this, State, setState, "delay.index.188"),  // special binding of param
                    CONSTS.REALTIME_CHECK_INTERVAL);

        var root = document.getElementById('main_root');
        var wd = Math.floor(root.offsetWidth);
        var ht = Math.floor(root.offsetHeight);
        var [vertical_mode, shape ] = setScreenOrientation(wd, ht, "INDEX.INIT.199");

        // TESTING ONLY: SCAFOLD TO DELAY TEST NEW CODE CONDITION - USE TIMEOUT() SO WON'T DEADLOCK
        var run_test = false;
        if(run_test) {
            setTimeout(()=> {
                console.log("init.98: ****** EXCUTE TEST FROM INDEX ...", Date.now()%100000/1000);
                handleNewVersion();
            }, 100)
        }


        getRedirectResult(State, setState, "index.376");     // MUST HAVE THIS, wait for redirect login to return results

        // process events
        INFO.wakeup_db_event = new Event('wakeup_db');     // when one of History or Video store is done
        INFO.version_event  = new Event('new_version');   // all data store is done, this is for cleanup
        INFO.system_ready_event  = new Event('system_ready');   // AI model is loaded  
        INFO.finished_event  = new Event('finished');   // all data store is done, this is for cleanup
        INFO.summary_event  = new Event('summary');   // all HISTORY data store is done, this is for cleanup
        INFO.session_close_event = new Event('session_close');   // alert UI layer to terminate session
        INFO.show_target_cone_event = new Event('show_cone');   // immeidately show target cone in <div> so there is no delay
        INFO.show_warning_event = new Event('show_warning');   // immeidately show target cone in <div> so there is no delay
        INFO.health_light_event = new Event('health_light');   // immeidately show target cone in <div> so there is no delay
        INFO.check_login_event = new Event('check_login');    // lower level check login
        INFO.get_redirect_event = new Event('get_redirect');    // lower level check login
        INFO.login_event = new Event('login_detected');       // lower level deteced a login
        INFO.logout_event = new Event('logout_detected');     // lower level deteced a logout
        INFO.has_user_state_event = new Event('has_user_state');   // user state loaded
        INFO.gesture_detected_event = new Event('gesture_detected');   // detect user gesture from webcam AI
        INFO.has_news_event = new Event('has_news');          // lower level deteced news content

        window.addEventListener('beforeinstallprompt', handleAddToHomeScreenEvent, false);
        window.addEventListener('wakeup_db', storeAllSessionData, false); // Listen for the event and write session to fb
        window.addEventListener('new_version', handleNewVersion, false); // need to restart new version
        window.addEventListener('system_ready', handleCanReboot, false); // notify user that system can be restarted
        window.addEventListener('login_detected', handleLoginEvent, false); // redirect to next stage
        window.addEventListener('logout_detected', handleLogoutEvent, false); // redirect to /auth
        window.addEventListener('get_redirect', handleRedirectEvent, false); // calls the check redirect in Index context
        //window.addEventListener('has_news', handleNewsEvent, false); // redirect to /auth
        //window.addEventListener("orientationchange", eventAdjustOrientation);

        return function cleanup() {
            console.log("init.494: ****** CLEAN UP LEAVING INDEX ...", Date.now()%100000/1000);
            window.removeEventListener('beforeinstallprompt', handleAddToHomeScreenEvent, false);
            window.removeEventListener('wakeup_db', storeAllSessionData, false); // Listen for the event and write session to fb
            window.removeEventListener('new_version', handleNewVersion, false); // need to restart new version
            window.removeEventListener('system_ready', handleCanReboot, false); // notify user that system can be restarted
            window.removeEventListener('login_detected', handleLoginEvent, false); // redirect to next stage
            window.removeEventListener('logout_detected', handleLogoutEvent, false); // redirect to /auth
            //window.removeEventListener('has_news', handleNewsEvent, false); // redirect to /auth
            //window.removeEventListener("orientationchange", eventAdjustOrientation);
        }
    }, [1]);


    useEffect(() => {

        if(State.authed === true) {
            // if regular login
            if (INFO.invite_key === null) { 
                console.log("index.363:       NOT INVITE_MODE = Loading User State");
                loadUserState(INFO.uid, null);    // make sure INFO.uid is set
            } else {
                if (auth.getCookie(CONSTS.COOKIE_LOGIN_COUNT >= 1)) {
                    console.log("index.407:       SECOND INVITE VISIT - Call loadUserState()  invite_key=",INFO.invite_key, " uid=",INFO.uid);
                    loadUserState(INFO.uid, INFO.invite_key);    // make sure INFO.uid is set
                } else {
                    // first invite of an existing user, do loadUserStaet() from the inviteUser() path
                    //
                    console.log("index.407:       FIRST INVITE VIST - Skip loadUserState()  invite_key=",INFO.invite_key, " uid=",INFO.uid);
                    auth.setCookie(CONSTS.COOKIE_INIT_VISIT, 0);       // no need for param restore
                    if (INFO.uid !== null) {
                        loadUserState(INFO.uid, INFO.invite_key);    // make sure INFO.uid is set
                    }
                }
            }
        } 

    }, [State.authed]);




    /*
    // reassess when screen is rotated on mobile
    //
    useEffect(() => {
        var root = document.getElementById('main_root');
        var wd = Math.floor(root.offsetWidth);
        var ht = Math.floor(root.offsetHeight);
        var [vertical_mode, shape ] = setScreenOrientation(wd, ht, "INDEX.CHK.271");
        INFO.vertical_mode = vertical_mode;
        console.log("adjust.2932:  SET ORIENTATION wd=",wd, "  ht=",ht, " INFO.vertical_mode=", INFO.vertical_mode);
    }, [CheckDisplay]);


    //function eventAdjustOrientation() {
        // set the count to trigger a React refresh, then check orientation
        //
        console.log("adjust.279:    INDEX ORIENTATION DETECTED  ",CheckDisplay);
        setCheckDisplay(CheckDisplay + 1);
    }
    */


    // event process for when login detected
    //
    const handleLoginEvent = () => {
        console.log("index.412:       RECEIVE LOGIN SIGNAL in INDEX");
        setState('authed', true);               // got user cred
        setState('show_redirect', true);        //

        INFO.redirect_path = (INFO.direct_start_mode === true) ?  "/auto1" : "/menu";     // TODO: verify

        setState('refresh_display', ++State.refresh_display);
    }

    // event process for when login detected
    //
    const handleLogoutEvent = () => {
        console.log("index.422:      RECEIVE LOGOUT SIGNAL in INDEX");
        setState('authed', false);               // got user cred
        setState('show_redirect', true);        //
        setState('refresh_display', ++State.refresh_display);
    }


    /*
    const handleNewsEvent = () => {
        console.log("index.586:      GOT NEWS EVENTS...", INFO.db_news);
        //setState('has_news', true); 
    }
    */


    const handleNewVersion = () => {
        console.log("index.83:  ******** SOFTWARE UPDATE REFRESH **********");
        INFO.show_download = true;
        if(Crash == null) {
            setCrash("NEW APP VERSION AVAILABLE, PLEASE WAIT");
            setShowUpdate(true);
        }
    }


    const handleCanReboot = () => {
        setButtonText("RESTART");
    }


    // OBSOLETE: DELETE ?
    // save this event so we can prompt the user at the right time
    //     - only will work with HTTPS (no localhost)
    //
    const handleAddToHomeScreenEvent = (event) => {
        console.log("index.499:  *********** DETECTED PWA_ADD_TO_HOME EVENT **********");
        INFO.install_pwa_event = event;
        addToHomeScreen();


        // only works for non-IOS chrome in production (no localhost)
        //
        function addToHomeScreen() { 
            var a2hsBtn = document.querySelector(".ad2hs-prompt"); // hide our user interface that shows our A2HS button 
            a2hsBtn.style.display = 'none'; // Show the prompt 

            INFO.install_pwa_event.prompt(); // Wait for the user to respond to the prompt 
            INFO.install_pwa_event.userChoice 
                .then((choiceResult) => { 
                if (choiceResult.outcome === 'accepted') { 
                    console.log('index.538:    ******** User accepted the A2HS prompt'); 
                } else { 
                    console.log('index.540:    ******** User dismissed the A2HS prompt'); 
                } 
                INFO.install_pwa_event = null;
            }); 
        } 

    }


    const handleRedirectEvent = () => {
        console.log("index.499:  ******** AUTH REDIRECT TIME ACTIVATED **********");
        setTimeout(()=> {
            getRedirectResult(State, setState, "event.redirect.499");     // In case index already done init
        },  CONSTS.REALTIME_CHECK_INTERVAL);
    }

    // restart after dismiss
    //
    const handleUpdateWait = event => {
        console.log("index.79:  DISABLE WAIT event=",event);
        setShowUpdate(false);
        setCrash(null);

        processServiceWorkerReload();
    }



    var getAdminMode = function() {
        var admin_mode = false;
        var path = props.location.pathname;
        var pbits = path.split("/");
        var lpath = pbits[pbits.length - 1];
        var host = window.location.hostname;
        var hbits = host.split(".");

        if((hbits[0] == "admin") || (lpath == "admin")) {
            admin_mode = true;
            console.log("idx.54:  *** START ADMIN MODE ***");
        }

        if(lpath == "test") {
            admin_mode = false;   // override
        }

        INFO.admin_mode = admin_mode;
        return admin_mode;
    }

    // TRICK: need this wrapper to support redirection after ai_avail
    //
    const Route1 = (props) => {
        if(State.ai_avail == true) {
            return <Route {...props} />
        }
        return <Redirect to='/splash' />
    }

                //{ ShowUpdate && <Wait Notice={Notice} Dismiss={handleUpdateWait} ShowSpinner={false} /> }
                        //<Route1 path="/menu" render={(props) => (<Dashboard {...props} />)} />
                        //<Route render={(props) => (<Auth {...props} />)} />
                        //<Route path="/splash" render={(props) => (<Splash Test={false} {...props} />)} />
                        //<Redirect to='/splash' to={{ pathname: "/splash", state: { title: "INFO.invite_key2" } }} />
                        //<Redirect to='/splash' to={{ pathname: "/splash", state: { title: "INFO.invite_key1" } }} />
                        //<Route1 path="/menu0" render={(props) => (<Menu {...props} />)} />
                        //<Route1 path="/analyze" render={(props) => (<Analyze {...props} />)} />

    return (
        <appContext.Provider value={{ State, Dispatch }}>
            <div id="main_root" className={classes.main_root} >
                { ShowUpdate && <FullScreen Message={Crash} /> }

                <BrowserRouter>
                  {(State.authed == true) ?
                    <React.Fragment>
                      <Switch>
                        <Route1 path="/auth" render={(props) => (<Auth {...props} />)} />
                        <Route1 path="/admin" render={(props) => (<Dev {...props} />)} />
                        <Route1 path="/auto1" render={(props) => (<Learn Mode={"auto1"} Drill={State.drill_key} {...props} />)} />
                        <Route1 path="/today" render={(props) => (<Learn Mode={"today"} {...props} />)} />
                        <Route1 path="/skill" render={(props) => (<Learn Mode={"skill"} {...props} />)} />
                        <Route1 path="/agility" render={(props) => (<Learn Mode={"game"} {...props} />)} />
                        <Route1 path="/condition" render={(props) => (<Learn Mode={"condition"} {...props} />)} />
                        <Route1 path="/challenge" render={(props) => (<Learn Mode={"perf"} {...props} />)} />
                        <Route1 path="/menu" render={(props) => (<Learn Mode={"dashboard"} {...props} />)} />
                        <Route1 path="/analyze" render={(props) => (<Learn MOde={"analyze"} {...props} />)} />
                        <Route path="/gif" render={(props) => (<Gif {...props} />)} />

                        <Route path="/tutorial" render={(props) => (<Tutorial {...props} />)} />
                        <Route path="/noai" render={(props) => (<Splash NoAI={true} {...props} />)} />
                        <Route path="/splash" render={(props) => (<Splash Test={false} Background={INFO.splash_image}
                                            ActiveDrill={INFO.active_drill}  Splash={INFO.splash}
                                            Invite={INFO.invite_key} {...props} />)} />
                        <Redirect to='/splash' />
                      </Switch>
                    </React.Fragment>
                  :
                    <React.Fragment>
                      <Switch>
                        <Route path="/auth" render={(props) => (<Auth {...props} />)} />
                        <Route path="/noai" render={(props) => (<Splash NoAI={true} {...props} />)} />
                        <Route path="/admin" render={(props) => (<Dev {...props} />)} />
                        <Route path="/privacy" render={(props) => (<Policy Text={PolicyText} {...props} />)} />
                        <Route path="/tos" render={(props) => (<Policy Text={PolicyText} {...props} />)} />
                        <Route path="/deletion" render={(props) => (<Policy Text={PolicyText} {...props} />)} />
                        <Route path="/gif" render={(props) => (<Gif {...props} />)} />
                        <Route path="/splash" render={(props) => (<Splash Test={false}  Background={INFO.splash_image}
                                            ActiveDrill={INFO.active_drill}  Splash={INFO.splash}
                                            Invite={INFO.invite_key} {...props} />)} />
                        <Redirect to='/splash' />
                      </Switch>
                    </React.Fragment>
                  }
                </BrowserRouter>
            </div>
        </appContext.Provider>
    );
}

export default withRouter(App)